module.exports = __webpack_public_path__ + "static/img/1981_phase_function_Paper_Points.576fca5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1981_phase_function_Paper_Points.png
// module id = yVac
// module chunks = 0